import { render, staticRenderFns } from "./Package4Card.vue?vue&type=template&id=93523f08&scoped=true"
import script from "./Package4Card.vue?vue&type=script&lang=ts"
export * from "./Package4Card.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93523f08",
  null
  
)

export default component.exports